export default {
    updated(el, binding) {
        if (el.tooltip) {
            el.tooltip.dispose();
            el.tooltip = null;

            handleTooltip(el, binding);
        }
    },
    mounted(el, binding) {
        handleTooltip(el, binding);
    },
    unmounted(el) {
        if (el.tooltip) {
            el.tooltip.dispose();
            el.tooltip = null;
        }
    }
};


const handleTooltip = (el, binding) => {
    let content = binding.value;

    if (!content) {
        return;
    }

    let allowHTML = content && typeof content === "object" && content.allowHTML;

    let tooltipOptions = {
        placement: binding.arg || "top",
        title: !!allowHTML ? content.content : String(content),
        trigger: "hover",
        html: !!allowHTML
    };

    if (!el.tooltip) {
        el.tooltip = new bootstrap.Tooltip(el, tooltipOptions);
    } else {
        el.tooltip.setContent({ ".tooltip-inner": content });
        el.tooltip.update();
    }
};
